export const Load3PLProviders =
  ({ RestService, ThreePlProvidersService, HandleError }) =>
  async () => {
    try {
      const providers = await RestService.get('/routes/three_pl_providers')

      ThreePlProvidersService.setProviders(providers)
    } catch (error) {
      HandleError({ error })
    }
  }
